import { render, staticRenderFns } from "./ContentArticleTemplateForm.vue?vue&type=template&id=7567e9b8"
import script from "./ContentArticleTemplateForm.vue?vue&type=script&lang=js"
export * from "./ContentArticleTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports